import type { FC } from "react";

import type { PrizeData, RedeemDialogLabels } from "../RedeemDialog";
import { DIALOG_STEP } from "../RedeemDialog";

import { RedemptionConfirmation } from "./RedemptionConfirmation";
import { RedemptionSummary } from "./RedemptionSummary";

import styles from "./DialogCard.module.scss";

export type QuantityType = {
  val: number;
  set: React.Dispatch<React.SetStateAction<number>>;
};

export type ShortenedLabels = Omit<
  RedeemDialogLabels,
  | "primaryCta"
  | "secondaryCta"
  | "dialogTitle"
  | "dialogTitleConfirmation"
  | "bottomText"
  | "confirmationMessage"
  | "confirmationMessagePlural"
>;

export type DialogCardProps = {
  pointsBalance: number;
  labels: ShortenedLabels;
  prizeData: PrizeData;
  dialogStep: DIALOG_STEP.CONFIRMATION | DIALOG_STEP.SUMMARY;
  codes: string[];
  quantity: QuantityType;
  type: string;
};

export const DialogCard: FC<DialogCardProps> = ({
  pointsBalance,
  labels,
  prizeData,
  dialogStep,
  codes,
  quantity,
  type,
}) => {
  const {
    unitLabel,
    pointsLabel,
    costLabel,
    availablePointsLabel,
    balanceAfterRedemptionLabel,
    emailLabel,
    emailHint,
    codeLabel,
    codeInfo,
    externalCodeButtonLabel,
    quantityAriaLabel,
    increaseAriaLabel,
    decreaseAriaLabel,
  } = labels;
  return (
    <div className={styles.content}>
      {dialogStep === DIALOG_STEP.SUMMARY && (
        <RedemptionSummary
          emailHint={emailHint}
          prizeData={prizeData}
          pointsBalance={pointsBalance}
          quantity={quantity}
          unitLabel={unitLabel}
          pointsLabel={pointsLabel}
          costLabel={costLabel}
          availablePointsLabel={availablePointsLabel}
          balanceAfterRedemptionLabel={balanceAfterRedemptionLabel}
          emailLabel={emailLabel}
          quantityAriaLabel={quantityAriaLabel}
          increaseAriaLabel={increaseAriaLabel}
          decreaseAriaLabel={decreaseAriaLabel}
        />
      )}
      {dialogStep === DIALOG_STEP.CONFIRMATION && (
        <RedemptionConfirmation
          externalCodeButtonLabel={externalCodeButtonLabel}
          codeLabel={codeLabel}
          codeInfo={codeInfo}
          codes={codes}
          type={type}
        />
      )}
    </div>
  );
};
